import React from 'react';
import './Pagination.scss';
import { ReactComponent as SVGNext } from '../../images/icons/chevron-right.svg';
import { ReactComponent as SVGPrevious } from '../../images/icons/chevron-left.svg';
import { useTranslation } from 'react-i18next';
import { useService } from 'react-service-locator';
import { SearchService } from '../../services/search.service';

const getPageWindow = (current: number, total: number, windowSize = 3) => {
    const half = Math.floor(windowSize / 2);
    let start = Math.max(1, current - half);
    const end = Math.min(total, start + windowSize - 1);
    start = Math.max(1, end - windowSize + 1);

    const pages: (number | '...')[] = [];

    if (start > 1) {
        pages.push(1);
        if (start > 2) pages.push('...');
    }

    for (let p = start; p <= end; p++) pages.push(p);

    if (end < total) {
        if (end < total - 1) pages.push('...');
        pages.push(total);
    }

    return pages;
};

const Pagination: React.FC = () => {
    const searchService = useService(SearchService);
    const { t } = useTranslation();
    const r = searchService.state.result;
    if (!r) return null;

    const pages = getPageWindow(r.pageNumber, r.totalPages, 3);

    return (
        <ul className="pagination">
            <li className="previous">
                <button
                    className={`body body-big link${!r.hasPrevious ? ' disabled' : ''}`}
                    onClick={() => searchService.gotoPage(r.pageNumber - 1)}
                    disabled={!r.hasPrevious}
                >
                    <SVGPrevious /> {t('components.pagination.previous')}
                </button>
            </li>

            {pages.map((p, i) =>
                p === '...' ? (
                    <li key={`dots-${i}`}>
                        <span className="body body-big">…</span>
                    </li>
                ) : (
                    <li key={`page-${p}`}>
                        <button
                            className={`body body-big btn ${p === r.pageNumber ? 'btn-active' : 'btn-enabled'}`}
                            disabled={p === r.pageNumber}
                            onClick={() => searchService.gotoPage(p)}
                        >
                            {p}
                        </button>
                    </li>
                ),
            )}

            <li className="next">
                <button
                    className={`body body-big link${!r.hasNext ? ' disabled' : ''}`}
                    onClick={() => searchService.gotoPage(r.pageNumber + 1)}
                    disabled={!r.hasNext}
                >
                    {t('components.pagination.next')} <SVGNext />
                </button>
            </li>
        </ul>
    );
};

export default Pagination;
